import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { PageElementViewModel, ConferenceViewModel, SponsorshipProductViewModel } from 'src/app/_models/generatedModels';
import { ProductListingData } from 'src/app/_models/models';
import { CallForSponsorsService } from 'src/app/_services/generatedServices';
import { SponsorshipCartService } from 'src/app/_services/sponsorship-cart.service';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-sponsor-product-listing',
  templateUrl: 'sponsor-product-listing.component.html',
})
export class SponsorProductListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  productListingData: ProductListingData;

  products: SponsorshipProductViewModel[];

  constructor(private callForSponsorsService: CallForSponsorsService, private router: Router, private cart: SponsorshipCartService, private toaster: ToasterService, private route: ActivatedRoute, private modalService: NgbModal) {}

  ngOnInit(): void {
    try{
    this.productListingData = JSON.parse(this.element.data);
    } catch {
      this.productListingData = new ProductListingData();
    }

    this.callForSponsorsService.getProductsForConference(this.conference.id.toString()).subscribe((products) => {
      var tags = Enumerable.from(this.productListingData.selectedTags);

      if (tags.any()) {
        this.products = products.filter((p) => tags.any((t) => p.tags.includes(t)) || (this.productListingData.includeNoTags && p.tags.length == 0));
      } else {
        this.products = products;
      }
      this.initialized = true;
    });
  }
}
